/**
 * grpc-gateway compatible query string serialization.
 * Serializes array parameters in the repeated-field format (corp_ids=1&corp_ids=2)
 * instead of the axios default format (corp_ids[]=1&corp_ids[]=2).
 *
 * Limitations — supports only scalar values and arrays of scalars, unlike the axios
 * default serializer:
 * - Date objects are NOT converted to ISO strings; they serialize via Date.toString()
 *   ("Mon Jul 06 2026 ..."). Format dates to strings before passing them.
 * - Plain objects serialize as "[object Object]" (axios default JSON.stringifies them).
 * - Strict percent-encoding: characters like ':' and ',' are encoded (%3A, %2C) rather
 *   than left literal as the axios default does. Decoded values are identical server-side.
 */
export const serializeRepeatedParams = (params: Dictionary<any>): string => {
  const pairs: Array<string> = []
  Object.keys(params || {}).forEach(key => {
    const value = params[key]
    if (value === undefined || value === null) return
    if (Array.isArray(value)) {
      value.forEach(item => pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`))
      return
    }
    pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
  })
  return pairs.join('&')
}
